<template>
  <div class="button-container">
    <span class="text-hover">Click me</span>
    <button>Explore</button>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.text-hover {
  position: absolute;
  text-align: center;
  width: 100%;
  color: var(--title-color);
  font-weight: var(--font-medium);
  font-size: var(--normal-font-size);
  overflow: hidden;
}
@-webkit-keyframes text {
  from {
    -webkit-mask-position: 0 0;
    mask-position: 0 0;
  }
  to {
    -webkit-mask-position: 100% 0;
    mask-position: 100% 0;
  }
}
@keyframes text {
  from {
    -webkit-mask-position: 0 0;
    mask-position: 0 0;
  }
  to {
    -webkit-mask-position: 100% 0;
    mask-position: 100% 0;
  }
}
@-webkit-keyframes text2 {
  from {
    -webkit-mask-position: 100% 0;
    mask-position: 100% 0;
  }
  to {
    -webkit-mask-position: 0 0;
    mask-position: 0 0;
  }
}
@keyframes text2 {
  from {
    -webkit-mask-position: 100% 0;
    mask-position: 100% 0;
  }
  to {
    -webkit-mask-position: 0 0;
    mask-position: 0 0;
  }
}

.button-container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 150px;
  height: 60px;
  margin-left: auto;
  margin-right: auto;
  overflow: hidden;
  border: 1px solid var(--first-color);
  font-weight: var(--font-medium);
  transition: 0.5s;
  letter-spacing: 1px;
  border-radius: 10px;
}
.button-container button {
  width: 100%;
  height: 100%;
  font-weight: var(--font-medium);
  font-size: var(--normal-font-size);
  letter-spacing: 1px;
  background: var(--first-color);
  -webkit-mask: url("/src/assets/css/hover.png");
  mask: url("/src/assets/css/hover.png");
  -webkit-mask-size: 7100% 100%;
  mask-size: 7100% 100%;
  border: none;
  color: var(--body-color);
  cursor: pointer;
  -webkit-animation: text2 0.6s steps(70) forwards;
  animation: text2 0.6s steps(70) forwards;
}
.button-container button:hover {
  -webkit-animation: text 0.6s steps(70) forwards;
  animation: text 0.6s steps(70) forwards;
}
</style>
